import type { Events, TimestampInMillis } from '@cobliteam/common-types';

export enum EventsActionNames {
  LOAD_EVENTS_INFO_SUCCEEDED = 'LOAD_EVENTS_INFO_SUCCEEDED',
  LOAD_EVENTS_INFO_REQUEST = 'LOAD_EVENTS_INFO_REQUEST',
  LOAD_EVENTS_INFO_FAILED = 'LOAD_EVENTS_INFO_FAILED',
}

export interface LoadEventsInfoSucceeded {
  type: EventsActionNames.LOAD_EVENTS_INFO_SUCCEEDED;
  payload: Events[];
}

export interface LoadEventsInfoRequest {
  type: EventsActionNames.LOAD_EVENTS_INFO_REQUEST;
  payload: {
    startDate: TimestampInMillis;
    endDate: TimestampInMillis;
  };
}

export interface LoadEventsInfoFailed {
  type: EventsActionNames.LOAD_EVENTS_INFO_FAILED;
}

export type EventsAction = LoadEventsInfoSucceeded | LoadEventsInfoRequest | LoadEventsInfoFailed;
